import moment from 'moment'

export const handleYearChange = (e: any, yearSelection: any) => {
  const removeIdx = yearSelection.indexOf(e.target.value)
  let newYearSelections = []

  if (removeIdx !== -1) {
    const clonedArray = [...yearSelection]
    clonedArray.splice(removeIdx, 1)
    newYearSelections = clonedArray
  } else {
    newYearSelections = [...yearSelection, e.target.value]
  }

  return newYearSelections
}

export const handleListFiltering = (
  localeListings: any,
  typeSelection: string,
  LISTING_TYPES: any,
  yearSelection: any,
  setFilteredListings: any,
) => {
  let filtered = localeListings

  if (typeSelection === LISTING_TYPES.ALL_ARTICLES) {
    filtered = filtered
  } else if (
    typeSelection === LISTING_TYPES.PRESS_RELEASES ||
    typeSelection === LISTING_TYPES.MEDIA_COVERAGE
  ) {
    filtered = filtered.filter((listing: any) => {
      if (typeSelection === LISTING_TYPES.PRESS_RELEASES) {
        return listing.articleType === 'Press Release'
      } else {
        return listing.articleType === undefined
      }
    })
  }

  if (yearSelection?.length > 0) {
    const yearSet = new Set(yearSelection)
    filtered = filtered.filter((listing: any) => {
      if (listing.date) {
        const listingDate = new Date(listing.date)

        if (listingDate) {
          const listingYear = moment(listingDate).utc().format('YYYY')
          return yearSet.has(listingYear)
        } else {
          return false
        }
      }
    })
  }

  setFilteredListings(filtered)
}
